module.exports = __webpack_public_path__ + "img/post_train_desktop.b1cd5fc9.png";